var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_244_33547",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_244_33547)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10.6667H24V5.33334H0V10.6667Z",
    fill: "#063191"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16H24V10.6667H0V16Z",
    fill: "#E2213B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.46666C12.3156 7.46666 12.5714 7.22788 12.5714 6.93333C12.5714 6.63878 12.3156 6.39999 12 6.39999C11.6844 6.39999 11.4286 6.63878 11.4286 6.93333C11.4286 7.22788 11.6844 7.46666 12 7.46666ZM9.71429 8C10.0299 8 10.2857 7.76122 10.2857 7.46667C10.2857 7.17211 10.0299 6.93333 9.71429 6.93333C9.39869 6.93333 9.14286 7.17211 9.14286 7.46667C9.14286 7.76122 9.39869 8 9.71429 8ZM14.8571 7.46667C14.8571 7.76122 14.6013 8 14.2857 8C13.9701 8 13.7143 7.76122 13.7143 7.46667C13.7143 7.17211 13.9701 6.93333 14.2857 6.93333C14.6013 6.93333 14.8571 7.17211 14.8571 7.46667ZM8.57143 9.6C8.88702 9.6 9.14286 9.36121 9.14286 9.06666C9.14286 8.77211 8.88702 8.53333 8.57143 8.53333C8.25584 8.53333 8 8.77211 8 9.06666C8 9.36121 8.25584 9.6 8.57143 9.6ZM16 9.06666C16 9.36121 15.7442 9.6 15.4286 9.6C15.113 9.6 14.8571 9.36121 14.8571 9.06666C14.8571 8.77211 15.113 8.53333 15.4286 8.53333C15.7442 8.53333 16 8.77211 16 9.06666Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.33333H24V0H0V5.33333Z",
    fill: "#FFD044"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVe);
export default __webpack_public_path__ + "static/media/VE.29b9b59c99071d16916788921ab236a0.svg";
export { ForwardRef as ReactComponent };